/**
 * STRIGHT ONE - Shopify 同意情報同期スクリプト（v3・ポーリング方式）
 * 仕様の詳細は consent-sync-implementation.md を参照。
 */
(function () {
  // ================= 設定 =================

  var POLL_INTERVAL = 1000;

  // sale_of_data（データ販売）の送信方法
  //   'none'      : 送信しない（Shopify の地域別既定値を維持）※推奨
  //   'marketing' : marketing の同意と同じ値を送信
  //   'deny'      : 常に false を送信（v2 までの挙動）
  var SALE_OF_DATA_MODE = 'none';

  var categoryMap = {
    'C94a00': 'analytics',
    'Cee000': 'marketing',
    'C4b300': 'preferences',
  };

  // ========================================

  var isShopifyReady = false;
  var lastSyncedSnapshot = null;
  var isSyncing = false;

  // Shopify標準バナーを非表示にするスタイルを適用する
  (function applyHideBannerStyles() {
    var style = document.createElement('style');
    style.textContent = `
      #shopify-section-cookie-banner,
      .shopify-cookie-banner,
      #shopify-pc__banner {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        height: 0 !important;
        pointer-events: none !important;
      }
      .cookie_consent-toggle {
        display: flex !important;
      }
    `;
    document.head.appendChild(style);
  })();

  // Shopify Customer Privacy API のロードを待機する
  function waitForShopifyPrivacy() {
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) {
          console.error('[Consent Sync] Shopify API ロードエラー:', error);
          return;
        }
        isShopifyReady = true;
      });
    } else {
      setTimeout(waitForShopifyPrivacy, 500);
    }
  }

  // getCookie() から同意データ（cat_status）を取得する
  function getConsentData() {
    if (!window.cookieConsent || !window.cookieConsent.settingObject) {
      return null;
    }
    try {
      var cookieData = window.cookieConsent.settingObject.getCookie();
      if (typeof cookieData === 'string') {
        cookieData = JSON.parse(cookieData);
      }
      if (!cookieData || !cookieData.data || !cookieData.data.cat_status) {
        return null;
      }
      return cookieData.data.cat_status;
    } catch (e) {
      console.error('[Consent Sync] 同意データ取得エラー:', e.message);
      return null;
    }
  }

  // cat_status を Shopify の同意設定オブジェクトに変換する
  function buildConsentSettings(catStatus) {
    var consentSettings = {
      analytics: false,
      marketing: false,
      preferences: false
    };

    catStatus.forEach(function (item) {
      var categoryCode = item[0];
      var consentValue = item[2];
      var isConsented = consentValue === 1;

      if (categoryMap[categoryCode]) {
        consentSettings[categoryMap[categoryCode]] = isConsented;
      }
    });

    if (SALE_OF_DATA_MODE === 'marketing') {
      consentSettings.sale_of_data = consentSettings.marketing;
    } else if (SALE_OF_DATA_MODE === 'deny') {
      consentSettings.sale_of_data = false;
    }

    return consentSettings;
  }

  // Shopify に同意設定を送信し、成功時のみ同期済み内容を記録する
  function syncConsentToShopify(catStatus, snapshot) {
    isSyncing = true;
    var consentSettings = buildConsentSettings(catStatus);

    window.Shopify.customerPrivacy.setTrackingConsent(consentSettings, function (result) {
      isSyncing = false;
      if (result && result.error) {
        console.error('[Consent Sync] Shopify への同期エラー:', result.error);
        return;
      }
      lastSyncedSnapshot = snapshot;
    });
  }

  // 同意状態を定期監視し、前回同期時から変更があれば Shopify へ同期する
  function pollConsentChanges() {
    if (isShopifyReady && !isSyncing) {
      var catStatus = getConsentData();

      if (catStatus) {
        var snapshot = JSON.stringify(catStatus);
        if (snapshot !== lastSyncedSnapshot) {
          syncConsentToShopify(catStatus, snapshot);
        }
      }
    }

    setTimeout(pollConsentChanges, POLL_INTERVAL);
  }

  // メイン処理
  waitForShopifyPrivacy();
  pollConsentChanges();
})();
